/**
 * Default app logo URL - used as fallback when companies haven't uploaded their own logo.
 * Companies can replace this by uploading a logo in their settings.
 */
export const DEFAULT_APP_LOGO = `${process.env.PUBLIC_URL || ''}/logo.png`;
